import React from 'react';
import { useTheme, Typography, Box, Stack } from '@mui/material';

const Aboutus = () => {
  const theme = useTheme();

  return (
    <div className='home'>
<div className='para'>

        <Typography
          variant="h5"
          color={theme.palette.secondary.sec}
          fontWeight="bold"
        >
          Зад технологиите стоят хора – опитни, вдъхновени, ангажирани.
        </Typography>

        <Typography variant="body1" color={theme.palette.secondary.other}>
          Нашият екип от специалисти комбинира дългогодишен опит в областта на недвижимите имоти, машинното обучение и софтуерното инженерство, за да създаде платформа, която работи с прецизност, надеждност и лекота. Ние не просто изграждаме технологично решение – ние създаваме инструмент, който носи реална стойност за всеки потребител.
        </Typography>
</div>
<div className='para'>
<Typography
          variant="h6"
          color={theme.palette.secondary.sec}
          fontWeight="bold"
        >
          Мисията ни? Да направим пазарът на имоти по-прозрачен, предвидим и достъпен.
        </Typography>

        <Typography variant="body1" color={theme.palette.secondary.other}>
          Работим с най-високи стандарти за качество и сигурност, като прилагаме най-новите технологии в анализа на големи обеми данни. Нашият екип следва строг процес на проектиране, тестване и оптимизация, за да гарантира, че всяка прогноза, всяка препоръка и всяка функционалност работят безупречно.
        </Typography>
</div>
<div className='para'>
<Typography
          variant="h6"
          color={theme.palette.secondary.sec}
          fontWeight="bold"
        >
          Екип от визионери и практици.
        </Typography>

        <Typography variant="body1" color={theme.palette.secondary.other}>
          От инженери по изкуствен интелект, през продуктови мениджъри и UX дизайнери, до специалисти по недвижими имоти – всеки от нас допринася със своя експертиза, за да създадем продукт, който е не само интелигентен, но и полезен, интуитивен и създаден с мисъл за потребителя.
        </Typography>

</div>
<div className='para'>
<Typography
          variant="h6"
          color={theme.palette.secondary.sec}
          fontWeight="bold"
        >
          Ние вярваме в устойчивото развитие.
        </Typography>

        <Typography variant="body1" color={theme.palette.secondary.other}>
          Платформата ни се подобрява ежедневно – както технологично, така и функционално. Всеки ред код и всяка нова функция са плод на внимателен анализ, обратна връзка от реални потребители и желание за постоянно усъвършенстване.
        </Typography>
</div>
<div className='para'>
<Typography
          variant="h6"
          color={theme.palette.secondary.sec}
          fontWeight="bold"
        >
          Създаваме технология, която работи за хората.
        </Typography>

        <Typography variant="body1" color={theme.palette.secondary.other}>
          Ако търсите не просто продукт, а партньор в процеса по покупка, продажба или анализ на имот – вие сте на правилното място. Добре дошли в платформата, където точността среща експертизата.
        </Typography>
</div>
    </div>
  )
};

export default Aboutus;
